import { makeStyles } from '@material-ui/core';

export default makeStyles({
  previewWrapper: {
    width: '100%',
    height: '100%',
    outline: 'none',
  },
});
